import type { Application } from '@hotwired/stimulus';
import { Controller } from '@hotwired/stimulus';

/**
 * Adds additional enhancements on content cards
 */
export class CardController extends Controller<HTMLElement> {
    static values = {
        linkAll: {
            type: Boolean,
            default: false,
        },
    };

    /**
     * Whether the whole card should be clickable as link when it contains
     * an anchor element
     */
    declare readonly linkAll: Boolean;

    static register(application: Application) {
        application.register('card', this);
    }

    /**
     * Make whole card clickable with a click event to resolve accessibility issues.
     * Do not wrap an HTMLAnchorElement around whole sections of content, especially when
     * it also can container nestes
     */
    linkAllValueChanged() {
        // We just assume the first link we hit, mostly the title of the card,
        // being the main link for the whole card click.
        const anchorElement = this.element.querySelector('a');
        let down;
        let up;

        if (anchorElement) {
            this.element.style.cursor = 'pointer';

            // Use mouseup/mousedown events instead of click events
            // to allow the user to still mark text in the card.
            this.element.onmousedown = () => (down = +new Date());
            this.element.onmouseup = (e: MouseEvent) => {
                up = +new Date();
                if (up - down < 200) {
                    // Resolve any issues with the link being opened twice by checking if the user
                    // clicks some other link in the card. If there are other links and the user clicks
                    // them, we just entirely stop the
                    if (!(e.target as HTMLAnchorElement).href) {
                        anchorElement.click();
                    }
                }
            };
        }
    }
}
